import React, { Suspense, useEffect, useState } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom"
import { Provider } from "react-redux"
import { Cookies, CookiesProvider } from "react-cookie"
import { Navigate } from 'react-router-dom';


import "./index.css"


import NoPage from "./components/NoPage"
import store from "./store"


///////////////////component should be initialize below////////////////

// ----------------------------------------------------------------------------------- Frontend Pages --------------------------------------------------------- //
import FrontendHeader from "./components/FrontendPages/frontendLayout/frontendHeader/FrontendHeader";
// import Home from "./components/FrontendPages/Home/Home"
// import BoilOutMethod from "./components/FrontendPages/Boil-out-method/BoilOutMethod"
// import TheFryRightSystem from "./components/FrontendPages/The-Fry-Right-System/TheFryRightSystem"
// import Blog from "./components/FrontendPages/Blog/Blog"
// import Product from "./components/FrontendPages/Product/ProductLists/Product"
// import Contact from "./components/FrontendPages/Contact/contact"
// import AddToCart from "./components/FrontendPages/Product/AddToCart/AddToCart";
// import StanceOnTheCascadeMethod from "./components/FrontendPages/StanceOnTheCascadeMethod/StanceOnTheCascadeMethod"
// import AchievingProgress from "./components/FrontendPages/AchievingAprogress/AchievingProgress"
// import GmAtTacoBellInOrem from "./components/FrontendPages/GmAtTacoBellInOrem/GmAtTacoBellInOrem"
// import FryingrightIsImportant from "./components/FrontendPages/FryingrightIsImportant/FryingrightIsImportant"
// import TotalPolarMaterial from "./components/FrontendPages/Total-Polar-Material/Total-Polar-Material"
// import MacKenzieRiverinButteMontana from "./components/FrontendPages/Mac-Kenzie-Riverin-Butte-Montana/Mac-Kenzie-Riverin-Butte-Montana"
// import FryrightSales from "./components/FrontendPages/FryrightSales/Fryright-Sales"
// import ForceWithinFrying from "./components/FrontendPages/Force-Within-Frying/Force-Within-Frying"
// import FryingaComplexChemistry from "./components/FrontendPages/Frying-A-Complex-Chemistry/frying-a-complex-chemistry.component"
// import GravityFlowFryers from "./components/FrontendPages/Gravity-Flow-Fryers/gravity-flow-fryers";
// import Fryrightherosonic from "./components/FrontendPages/Fry-Right-Herosonic/fry-right-hero-sonic";
// import FryrightConsistent from "./components/FrontendPages/FryrightConsistent/fry-right-consistent";
// import Success from "./components/FrontendPages/Product/Success/Success";

// --------------------------------------------------------------------------------- Backend Pages ---------------------------------------------------------------- //
import Layout from "./components/Layout"
// import { Dashboard } from "./components/dashboard/Dashboard"
// import Login from "./components/login/Login"
// import AddeditLessons from "./components/traningModule/AddeditLessons/addeditlessons"
// import TraningList from "./components/traningModule/TraningList/TraningList"
// import ProductList from "./components/productManagement/productlist"
// import AddeditTraning from "./components/traningModule/AddeditTraning/AddeditTraning"
// import LessonsList from "./components/traningModule/LessonsList/LessonsList"
// import TraningCenter from "./components/traningModule/TraningCenter/TraningCenter";
// import ForgetPassword from "./components/ForgetPassword"
// import ShopList from "./components/shopManagement/shoplist";
// import VatList from "./components/vatManagement/VatList";
// import VatAddEdit from './components/vatManagement/VatAddEdit';
// import AddeditShop from "./components/shopManagement/addeditshop";
// import GeneralLink from "./components/dashboard/ShareLinks/GeneralLink/GeneralLink";
// import ShareLinks from "./components/dashboard/ShareLinks/ShareLinks"
// import TPM from "./components/dashboard/ShareLinks/TPM/TPM";
// import TopOfCycle from "./components/dashboard/ShareLinks/TopOfCycle/TopOfCycle";
// import MyAccount from "./components/MyAccount"
// import ForgotPasswordPage from "./components/ForgotPasswordPage"
// import UserManagementEdit from "./components/users/UserManagementEdit"
// import UserManagement from "./components/users/UserManagement"
// import Testimonials from "./components/FrontendPages/Testimonials/testimonials"
// import About from "./components/FrontendPages/About Us/about-us"


import { setProductAccessOfShop } from "./components/dashboard/userDashboardReducer";
import { setLogedinUserInfo } from "./components/login/Login_reducer";
import Slides from "./Slides"
import NewFryRightSystem from "./components/FrontendPages/New-Fry-Right-System/NewFryRightSystem"




// -------------------------------------------------------------------------- React Lazy Loading ----------------------------------------------------------------------- //
// -------------------------------------------------------------------------- React Lazy Loading Frontend Pages ----------------------------------------------------------------------- //
// const FrontendHeader = React.lazy(() => import('./components/FrontendPages/frontendLayout/frontendHeader/FrontendHeader'))
const Home = React.lazy(() => import('./components/FrontendPages/Home/Home'))
const BoilOutMethod = React.lazy(() => import('./components/FrontendPages/Boil-out-method/BoilOutMethod'))
const TheFryRightSystem = React.lazy(() => import('./components/FrontendPages/The-Fry-Right-System/TheFryRightSystem'))
const Blog = React.lazy(() => import('./components/FrontendPages/Blog/Blog'))
const Product = React.lazy(() => import('./components/FrontendPages/Product/ProductLists/Product'))
const Contact = React.lazy(() => import('./components/FrontendPages/Contact/contact'))
const AddToCart = React.lazy(() => import('./components/FrontendPages/Product/AddToCart/AddToCart'))
const StanceOnTheCascadeMethod = React.lazy(() => import('./components/FrontendPages/StanceOnTheCascadeMethod/StanceOnTheCascadeMethod'))
const AchievingProgress = React.lazy(() => import('./components/FrontendPages/AchievingAprogress/AchievingProgress'))
const GmAtTacoBellInOrem = React.lazy(() => import('./components/FrontendPages/GmAtTacoBellInOrem/GmAtTacoBellInOrem'))
const FryingrightIsImportant = React.lazy(() => import('./components/FrontendPages/FryingrightIsImportant/FryingrightIsImportant'))
const TotalPolarMaterial = React.lazy(() => import('./components/FrontendPages/Total-Polar-Material/Total-Polar-Material'))
const MacKenzieRiverinButteMontana = React.lazy(() => import('./components/FrontendPages/Mac-Kenzie-Riverin-Butte-Montana/Mac-Kenzie-Riverin-Butte-Montana'))
const FryrightSales = React.lazy(() => import('./components/FrontendPages/FryrightSales/Fryright-Sales'))
const ForceWithinFrying = React.lazy(() => import('./components/FrontendPages/Force-Within-Frying/Force-Within-Frying'))
const FryingaComplexChemistry = React.lazy(() => import('./components/FrontendPages/Frying-A-Complex-Chemistry/frying-a-complex-chemistry.component'))
const GravityFlowFryers = React.lazy(() => import('./components/FrontendPages/Gravity-Flow-Fryers/gravity-flow-fryers'))
const Fryrightherosonic = React.lazy(() => import('./components/FrontendPages/Fry-Right-Herosonic/fry-right-hero-sonic'))
const FryrightConsistent = React.lazy(() => import('./components/FrontendPages/FryrightConsistent/fry-right-consistent'))
const Success = React.lazy(() => import('./components/FrontendPages/Product/Success/Success'))
const Testimonials = React.lazy(() => import('./components/FrontendPages/Testimonials/testimonials'))
const About = React.lazy(() => import('./components/FrontendPages/About Us/about-us'))


// ------------------------------------------------------------------ React Lazy Loading Backend Pages ------------------------------------------------------------------------------------ //
// const Layout = React.lazy(() => import("./components/Layout"))
const Login = React.lazy(() => import('./components/login/Login'))
const Dashboard = React.lazy(() => import('./components/dashboard/Dashboard'))
const AddeditLessons = React.lazy(() => import('./components/traningModule/AddeditLessons/addeditlessons'))
const TraningList = React.lazy(() => import('./components/traningModule/TraningList/TraningList'))
const ProductList = React.lazy(() => import('./components/productManagement/productlist'))
const AddeditTraning = React.lazy(() => import('./components/traningModule/AddeditTraning/AddeditTraning'))
const LessonsList = React.lazy(() => import('./components/traningModule/LessonsList/LessonsList'))
const TraningCenter = React.lazy(() => import('./components/traningModule/TraningCenter/TraningCenter'))
const ForgetPassword = React.lazy(() => import('./components/ForgetPassword'))
const ShopList = React.lazy(() => import('./components/shopManagement/shoplist'))
const VatList = React.lazy(() => import('./components/vatManagement/VatList'))
const VatAddEdit = React.lazy(() => import('./components/vatManagement/VatAddEdit'))
const AddeditShop = React.lazy(() => import('./components/shopManagement/addeditshop'))
const GeneralLink = React.lazy(() => import('./components/dashboard/ShareLinks/GeneralLink/GeneralLink'))
const ShareLinks = React.lazy(() => import('./components/dashboard/ShareLinks/ShareLinks'))
const TPM = React.lazy(() => import('./components/dashboard/ShareLinks/TPM/TPM'))
const TopOfCycle = React.lazy(() => import('./components/dashboard/ShareLinks/TopOfCycle/TopOfCycle'))
const MyAccount = React.lazy(() => import('./components/MyAccount'))
const ForgotPasswordPage = React.lazy(() => import('./components/ForgotPasswordPage'))
const UserManagementEdit = React.lazy(() => import('./components/users/UserManagementEdit'))
const UserManagement = React.lazy(() => import('./components/users/UserManagement'))
const SafetyMeasurements = React.lazy(() => import('./components/common/SafetyMeasurements'))
const BrandList = React.lazy(() => import('./components/BrandManagement/BrandManagementList'))
const TestimonialList = React.lazy(() => import('./components/ManageTestimonials/testimoniallist'))
const ManageLocation = React.lazy(() => import('./components/Managelocation/managelocation'))
const ManageBlog = React.lazy(() => import('./components/Blog/blogList'))







////////////////////////////////////////// Get Cookies from browser and set into Store ////////////////////////////////////
const getCookiesSetStore = () => {
  const cookies = new Cookies();
  const getcookies = cookies.getAll();
  console.log("getcookies from index==>", getcookies);
  if (getcookies !== null && getcookies !== undefined && Object.keys(getcookies).length > 0) {
    console.log('getcookies==>', getcookies)
    store.dispatch(setLogedinUserInfo(getcookies));
  }

  if (getcookies.store_access !== null && getcookies.store_access !== undefined && Object.keys(getcookies).length > 0) {
    console.log('getcookies==>', getcookies)
    store.dispatch(setProductAccessOfShop({ store_access: getcookies.store_access }));
  }

}
////////////////////////////////// Call the getCookiesSetStore function /////////////////////////////////////
getCookiesSetStore();


const useAuth = () => {
  console.log("AUTHED++++++++++", store.getState().loginUserKey.isLoggedIn)
  return store.getState().loginUserKey.isLoggedIn;
}

const PrivateRoute = ({ children }) => {
  const auth = useAuth();
  return (
    auth === true ? children : <Navigate to="/login" replace={true} />
  )
}

const PrivateRouteWoId = ({ children, route }) => {
  const params = useParams();
  console.log("authed======>", useAuth(), params, route);
  const auth = useAuth();
  return (
    auth === true ? children : <Navigate to="/login" state={{ navigateTo: ((route && params.id) ? `/${route}/${params.id}` : '') }} replace={true} />
  )
}

const TPMTopOffInputPrivateRoute = ({ children, route }) => {
  const params = useParams();
  console.log("authed======>", useAuth(), params, route);
  const auth = useAuth();
  return (
    auth === true ? children : <Navigate to="/login" state={{ navigateTo: ((route && params._id) ? `/${route}/${params._id}` : '') }} replace={true} />
  )
}

const LoginRoute = ({ children, redirectPath }) => {
  const auth = useAuth();
  return (auth !== true) ? children : <Navigate to={redirectPath} replace={true} />
}


const PasswordRoute = ({ children }) => {
  const auth = useAuth();
  return (auth !== true) ? children : <Navigate to="/login" replace={true} />
}



export function App() {
  return (
    <CookiesProvider>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            {/*--------------------------------------- Frontend Pages --------------------------------------------------*/}
            <Route path="/" element={<FrontendHeader />}>
              <Route index element={<Suspense fallback={<></>}><Home /></Suspense>} />
              <Route path="home" element={<Suspense fallback={<></>}><Home /></Suspense>} />
              <Route path="boil-out-method" element={<Suspense fallback={<></>}><BoilOutMethod /></Suspense>} />
              <Route path="the-fry-right-system" element={<Suspense fallback={<></>}><NewFryRightSystem  /></Suspense>} />
              <Route path="new-the-fry-right-system" element={<Suspense fallback={<></>}><NewFryRightSystem /></Suspense>} />
              <Route path="contact" element={<Suspense fallback={<></>}><Contact /></Suspense>} />
              <Route path="blog" element={<Suspense fallback={<></>}><Blog /></Suspense>} />
              <Route path="product" element={<Suspense fallback={<></>}><Product /></Suspense>} />
              <Route path="add-to-cart" element={<Suspense fallback={<></>}><AddToCart /></Suspense>} />
              <Route path="success" element={<Suspense fallback={<></>}><Success /></Suspense>} />
              <Route path="stance-on-the-cascade-method" element={<Suspense fallback={<></>}><StanceOnTheCascadeMethod /></Suspense>} />
              <Route path="blog-details/:id" element={<Suspense fallback={<></>}><StanceOnTheCascadeMethod /></Suspense>} />
              <Route path="achieving-progress" element={<Suspense fallback={<></>}><AchievingProgress /></Suspense>} />
              <Route path="gm-at-taco-bell-in-orem" element={<Suspense fallback={<></>}><GmAtTacoBellInOrem /></Suspense>} />
              <Route path="frying-right-is-important" element={<Suspense fallback={<></>}><FryingrightIsImportant /></Suspense>} />
              <Route path="total-polar-material" element={<Suspense fallback={<></>}><TotalPolarMaterial /></Suspense>} />
              <Route path="mac-kenzie-riverin-butte-montana" element={<Suspense fallback={<></>}><MacKenzieRiverinButteMontana /></Suspense>} />
              <Route path="fryright-sales" element={<Suspense fallback={<></>}><FryrightSales /></Suspense>} />
              <Route path="force-within-frying" element={<Suspense fallback={<></>}><ForceWithinFrying /></Suspense>} />
              <Route path="frying-a-complex-chemistry" element={<Suspense fallback={<></>}><FryingaComplexChemistry /></Suspense>} />
              <Route path="gravity-flow-fryers" element={<Suspense fallback={<></>}><GravityFlowFryers /></Suspense>} />
              <Route path="fryright-hero-sonic" element={<Suspense fallback={<></>}><Fryrightherosonic /></Suspense>} />
              <Route path="fryright-consistent" element={<Suspense fallback={<></>}><FryrightConsistent /></Suspense>} />
              <Route path="testimonials" element={<Suspense fallback={<></>}><Testimonials /></Suspense>} />
              <Route path="about-us" element={<Suspense fallback={<></>}><About /></Suspense>} />
            </Route>


            {/* ----------------------------------------- Backend Pages ---------------------------------------------------- */}
            <Route path="/" element={<Layout />}>
              <Route path="login" element={<LoginRoute redirectPath={`/${(store?.getState()?.loginUserKey?.userInfo?.type)?.replaceAll('_', '-')}-dashboard`}><Suspense fallback={<></>}><Login /></Suspense></LoginRoute>} />
              <Route path="login/forgot-password" element={<PasswordRoute><Suspense fallback={<></>}><ForgetPassword /></Suspense></PasswordRoute>} />
              <Route path="forgot-password/:_id/:token" element={<PasswordRoute><Suspense fallback={<></>}><ForgotPasswordPage /></Suspense></PasswordRoute>} />
              <Route path=":userTypeDashboard" element={<PrivateRoute><Suspense fallback={<></>}><Dashboard /></Suspense></PrivateRoute>} />
              <Route path="list-training" element={<PrivateRoute><Suspense fallback={<></>}><TraningList /></Suspense></PrivateRoute>} />
              <Route path="add-edit-lessons" element={<Suspense fallback={<></>}><AddeditLessons /></Suspense>} />
              <Route path="list-lessons" element={<PrivateRoute><Suspense fallback={<></>}><LessonsList /></Suspense></PrivateRoute>} />
              <Route path="trainingcenter/:id" element={<PrivateRouteWoId route="trainingcenter"><Suspense fallback={<></>}><TraningCenter /></Suspense></PrivateRouteWoId>} />
              <Route path="trainingcenter/:id/:lessonId" element={<PrivateRoute><Suspense fallback={<></>}><TraningCenter /></Suspense></PrivateRoute>} />
              <Route path="list-shop" element={<PrivateRoute><Suspense fallback={<></>}><ShopList /></Suspense></PrivateRoute>} />
              <Route path="brand-list" element={<PrivateRoute><Suspense fallback={<></>}><BrandList /></Suspense></PrivateRoute>} />
              <Route path="shop-add-edit" element={<PrivateRoute><Suspense fallback={<></>}><AddeditShop /></Suspense></PrivateRoute>} />
              <Route path="vat-list" element={<PrivateRoute><Suspense fallback={<></>}><VatList /></Suspense></PrivateRoute>} />
              <Route path="vat-add-edit" element={<PrivateRoute><Suspense fallback={<></>}><VatAddEdit /></Suspense></PrivateRoute>} />
              <Route path="general-link/:_id" element={<TPMTopOffInputPrivateRoute route='general-link'><Suspense fallback={<></>}><GeneralLink /></Suspense></TPMTopOffInputPrivateRoute>} />
              <Route path="share-links" exact element={<Suspense fallback={<></>}><ShareLinks /></Suspense>} />
              <Route path="tpm/:_id" element={<TPMTopOffInputPrivateRoute route="tpm"><Suspense fallback={<></>}><TPM /></Suspense></TPMTopOffInputPrivateRoute>} />
              <Route path="top-up-cycle/:_id" element={<TPMTopOffInputPrivateRoute route="top-up-cycle"><Suspense fallback={<></>}><TopOfCycle /></Suspense></TPMTopOffInputPrivateRoute>} />
              <Route path="product/list" element={<PrivateRoute><Suspense fallback={<></>}><ProductList /></Suspense></PrivateRoute>} />
              <Route path="users" element={<PrivateRoute><Suspense fallback={<></>}><UserManagement /></Suspense></PrivateRoute>} />
              {/* <Route path="edit/user/:id" element={<PrivateRouteWoId route="edit" ><Suspense fallback={<></>}><UserManagementEdit /></Suspense></PrivateRouteWoId>} /> */}
              <Route path="myaccount" element={<PrivateRoute><Suspense fallback={<></>}><MyAccount /></Suspense></PrivateRoute>} />
              <Route path="add-edit-traning" element={<PrivateRoute><Suspense fallback={<></>}><AddeditTraning /></Suspense></PrivateRoute>} />
              <Route path="safety-measurements" element={<PrivateRoute><Suspense fallback={<></>}><SafetyMeasurements /></Suspense></PrivateRoute>} />
              <Route path="testimonials/list" element={<PrivateRoute><Suspense fallback={<></>}><TestimonialList /></Suspense></PrivateRoute>} />
              <Route path="manage-locations" element={<PrivateRoute><Suspense fallback={<></>}><ManageLocation /></Suspense></PrivateRoute>} />
              <Route path="manage-blog" element={<PrivateRoute><Suspense fallback={<></>}><ManageBlog /></Suspense></PrivateRoute>} />
              
              
              
              
            </Route>
            <Route path="*" element={<NoPage />} />
            <Route path="/temp" element={<Slides />} />

          </Routes>
        </BrowserRouter>
      </Provider>
    </CookiesProvider>
  )
}
console.log("env==>", process.env)

const container = document.getElementById("root")
const root = createRoot(container)
root.render(<App />)

